
import React, { useEffect, useState } from 'react'
import { Button, Grid, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { useTranslation } from 'react-i18next';
import { SuccessIcon, ErrorIcon } from '../../components/CustomIcons';
import CustomHeader from '../../components/CustomHeader';
import wsclients from '../../services/wsclients';
import { paths } from '../../config/router.config';
import { useHistory } from 'react-router-dom';
import CustomAlert from '../../components/CustomAlert';
import CustomLoading from '../../components/CustomLoading';

const useStyles = makeStyles((theme) => ({
    content: {
        padding: theme.spacing(2),
        paddingTop: theme.spacing(10),
    },
}));

export default function VumatelUpdateCard(props) {
    const classes = useStyles();
    const { t } = useTranslation();
    const history = useHistory();

    const [showLoading, onShowLoading] = useState(false);
    const [message, setMessage] = useState(null);
    const [result, setResult] = useState(null);
    const [showTextRedirect, setShowTextRedirect] = useState(undefined);

    useEffect(() => {
        onLoad();
    }, []);

    const onLoad = async () => {
        onShowLoading(true);
        var url = new URL(window.location.href);
        console.log("url===", url);
        let id = null;
        if(url.pathname && url.pathname.includes("/vumatel/updatecard/")){
            let strPathName = url.pathname.split("/vumatel/updatecard/");
            if(strPathName && strPathName.length > 0 && strPathName[1]){
                id = strPathName[1];
            }
        }
        if(id) await getVumatelUpdateCard(id);
        onShowLoading(false)
    }

    const getVumatelUpdateCard = async (id) => {
        try {
            var result = await wsclients.lab4services.getVumatelUpdateCard(id);
            console.log("getVumatelUpdateCard result====", result);
            if(result.code == 'OK'){
                if(result.data && result.data.payment_url) {
                    setResult({
                        status: 'success',
                    })
                    setShowTextRedirect(true);
                    window.location.href = result.data.payment_url;
                }else{
                    setResult({
                        status: 'failed',
                    })
                    setShowTextRedirect(false);
                }
            } else if (result.code === 'VUMATEL_SERVER_ERROR'){
                setResult({
                    status: 'failed',
                })
                setShowTextRedirect(false);
                // onShowMessage({
                //     show: true,
                //     content: t('VUMATEL_SERVER_ERROR'),
                // });
            } else{
                let enity = result.data && result.data.error && result.data.error.entity ? JSON.parse(result.data.error.entity) : t('ERROR');
                setResult({
                    status: 'failed',
                })
                setShowTextRedirect(false);
                // onShowMessage({
                //     show: true,
                //     content: enity && enity.detail ? enity.detail : t('ERROR'),
                // });
            }
        }
        catch (ex) {
            console.log("getVumatelUpdateCard exception===", ex);
        }
    }

    const onShowMessage = (message) => {
        onShowLoading(false)
        setMessage(message)
    }

    return (
        <Grid item xs={12}>
            {/* <CustomHeader hideMenu={true} nomargin={true}/> */}
            <Grid xs={12} item container justifyContent='center' className={classes.content}>
                <Grid item xs={12} container justifyContent='center'>
                    {result && result.status === 'success' && <SuccessIcon style={{ fontSize: 50 }} />}
                    {result && result.status === 'failed' && <ErrorIcon style={{ fontSize: 50 }} />}
                </Grid>
                <Grid xs={12} item container justifyContent='center' marginTop={4}>
                    {showTextRedirect && <Typography variant='body2'>{t('UPDATE_CARD_MESSAGE')}</Typography>}
                    {showTextRedirect === false && <Typography variant='body2'>{t('ERROR_RETRY_PAYMENT')}</Typography>}
                </Grid>
                <Grid xs={12} item container justifyContent='center' marginTop={4}>
                    <Button variant='contained' onClick={() => history.push(paths.home)}>{t('btn_back_to_home')}</Button>
                </Grid>
            </Grid>
            {showLoading && <CustomLoading open={showLoading} />}
            {message && message.show && <CustomAlert
                open={message.show}
                message={message.content}
                showButtonClose={true}
                onClose={message.action ? message.action : () => onShowMessage({})}
            />}
        </Grid>
    );
}